<template lang="pug">
  .project
    .pro-image(:style="{ 'background-image': 'url(' + detailProject.image + ')',  }")
      .item-hover(v-if="detailProject.link")
        .circle
          a(:href="detailProject.link" target="_blank")
            img(src="static/ic_link.svg")
    .pro-content
      .title.is-5 {{detailProject.name}}
      .menu-label(v-for="t in detailProject.mainTag") /{{t}}
      p {{detailProject.description}}
      .award(v-if="detailProject.awards")
        br
        .title.is-6 Award
        .is-6(v-for="a in detailProject.awards" style="margin-top: 3px") -
          a(:href="a.link" target="blank" style="font-size: .9em; padding-left: 6px") {{a.name}}
      .tagContain
        span.tag(v-for="t in detailProject.tags") {{t}}
</template>

<script>

export default {
  name: 'Project',
  props: {
    detailProject: Object
  },
  methods: {
    cutWords (text) {
      const maxLength = 260
      const trimmedString = text.substr(0, maxLength)
      return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')))
    }
  }
}
</script>

<style lang="sass" scoped>
.project
  width: 100%
  box-shadow: 8px 14px 38px rgba(39,44,49,.06), 1px 3px 8px rgba(39,44,49,.03)
  transition: all .5s ease
  border-radius: 5px
  &:hover
    box-shadow: 0 0 1px rgba(39,44,49,.1), 0 3px 16px rgba(39,44,49,.07)
    transform: translate3D(0,-1px,0)
    .pro-image
      .item-hover
        opacity: 1
  .pro-image
    display: block
    height: 30vh
    width: 100%
    background-repeat: no-repeat
    background-size: cover
    background-position: center center
    .item-hover
      opacity: 0
      display: block
      width: 100%
      height: 100%
      transition: .4s ease
      background-color: rgba(black, 0.5)
      position: relative
      .circle
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        background-color: rgba(#fff, 0.7)
        width: 48px
        height: 48px
        border-radius: 999px
        transform-origin: center
        padding: 8px
        transition: .3s ease
        &:hover
          background-color: #fff
        a img
          width: 48px
          transform: rotate(-45deg)

  .pro-content
    display: block
    padding: 1em
    width: 100%
    background-color: #fff
    .title
      margin: 0
    .menu-label
      display: inline-block
      padding-right: 6px
    .tagContain
      margin-top: 24px
      padding: 8px 0
      border-top: solid 1px rgba(black, 0.1)
      .tag
        margin-right: 6px

</style>



// WEBPACK FOOTER //
// src/components/Project.vue